// extracted by mini-css-extract-plugin
export default {"mainc":"SharedLayout_mainc__Hug60","main":"SharedLayout_main__ColIW"};